import React from "react";
import { footer } from "../../../data/footer";

const Footer = () => {
  return (
    <footer
      style={{
        padding: "2rem 1rem",
        textAlign: "center",
        borderTop: "1px solid rgba(255, 255, 255, 0.05)",
        background: "var(--bg-secondary)",
      }}
    >
      <p
        style={{
          margin: 0,
          fontSize: "0.85rem",
          color: "var(--text-muted)",
          letterSpacing: "0.5px",
        }}
      >
        <span style={{ color: "var(--primary-color)" }}>Abdellah Khedid</span> — Full-stack web, mobile &amp; AI integration · {footer.year}
      </p>
    </footer>
  );
};

export default Footer;
